import { KeyRound, UserCheck, FileSignature } from "lucide-react";

const ITEMS = [
    {
        key: "custody",
        icon: KeyRound,
        title: "Custody",
        body: "Who controls the relevant wallet, data, asset, role, model, evidence or process — and where it physically lives.",
    },
    {
        key: "authority",
        icon: UserCheck,
        title: "Authority",
        body: "Who is authorised to request, approve, refuse, escalate, share, deploy, pause, override or hand off.",
    },
    {
        key: "receipts",
        icon: FileSignature,
        title: "Receipts",
        body: "What evidence proves what happened: who acted, what was shared, what was withheld, what authority applied and where the decision boundary was crossed.",
    },
];

export default function CarExplainer({ compact = false }) {
    return (
        <section
            className={`grid grid-cols-1 md:grid-cols-3 ${compact ? "gap-4" : "gap-6"}`}
            data-testid="car-explainer"
        >
            {ITEMS.map(({ key, icon: Icon, title, body }) => (
                <div
                    key={key}
                    className="tile rounded-sm p-6"
                    data-testid={`car-${key}`}
                >
                    <Icon size={20} strokeWidth={1.5} className="text-slate-900 mb-4" />
                    <div className="overline mb-2">{title}</div>
                    <p className="text-sm text-slate-700 leading-relaxed">{body}</p>
                </div>
            ))}
        </section>
    );
}
